<template>
  <div>
    <base-crud
      :ref="table"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
      :detailUrl="detailUrl"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data() {
    return {
      detailUrl: "document",
      error: "",
      crudName: "Documentos",
      newText: "Cadastrar Documento",
      table: "documentsTable",
      columns: ["id", "name", "actions"],
      tableData: ["id", "name"],
      options: {
        sortIcon: {
          base: "space_fas fas",
          is: "fa-sort",
          up: "fa-sort-amount-up",
          down: "fa-sort-amount-down",
        },
        filterByColumn: true,
        debounce: 1000,
        sortable: ["id", "name"],
        filterable: ["id", "name"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          name: "Nome",
          id: "#",
          actions: "Ações",
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "signaturedocuments/",
      dataForm: {},
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
      };
      let filters = "&orderByDesc=id&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
  },
  components: {
    BaseCrud,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Document/Crud.vue